import { CascadiaCustomIcon } from "@certn/cascadia-tokens";
import React from "react";

export const customIconComponents: Record<CascadiaCustomIcon, React.ReactNode> =
  {
    "user-profile-circle": (
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="person icon"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 10.629c2.23 0 4.038-1.842 4.038-4.115C16.038 4.242 14.23 2.4 12 2.4c-2.23 0-4.038 1.842-4.038 4.114 0 2.273 1.808 4.115 4.038 4.115ZM12 21.6c3.393 0 6.425-1.608 8.4-4.114-1.975-2.507-5.007-4.115-8.4-4.115-3.393 0-6.425 1.608-8.4 4.115C5.575 19.992 8.607 21.6 12 21.6Z"
        />
      </svg>
    ),
    bullet: (
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M15.6 12a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0Z" />
      </svg>
    ),
    select: (
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11.223 17.674 8.34 14.848c-.351-.344-.43-.738-.235-1.182.194-.444.54-.666 1.04-.666h5.713c.499 0 .845.222 1.039.666.194.444.116.838-.235 1.182l-2.884 2.826A1.064 1.064 0 0 1 12 18a1.064 1.064 0 0 1-.777-.326ZM12.777 6.326l2.884 2.826c.351.344.43.738.235 1.182-.194.444-.54.666-1.04.666H9.144c-.499 0-.845-.222-1.039-.666-.195-.444-.116-.838.235-1.182l2.884-2.826c.111-.109.232-.19.361-.244.13-.055.268-.082.416-.082a1.063 1.063 0 0 1 .777.326Z" />
      </svg>
    ),
    google: (
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.6626 17.2355C17.6266 15.4028 18.4993 12.3483 17.9756 9.42432H10.1645V12.6541H14.6153C14.4408 13.7013 13.8299 14.5741 12.9572 15.141L15.6626 17.2355Z"
          fill="#4285F4"
        />
        <path
          d="M2.74629 14.6615C3.32035 15.7922 4.14362 16.7779 5.15402 17.5442C6.16442 18.3105 7.33561 18.8375 8.57927 19.0853C9.82293 19.3332 11.1067 19.2955 12.3336 18.9751C13.5606 18.6547 14.6988 18.0599 15.6625 17.2356L12.9571 15.1411C10.6441 16.6687 6.80409 16.1011 5.49501 12.5229L2.74629 14.6615Z"
          fill="#34A853"
        />
        <path
          d="M5.49555 12.5228C5.14646 11.4316 5.14646 10.4283 5.49555 9.33703L2.74614 7.19922C1.74216 9.20647 1.43706 12.0432 2.74614 14.6613L5.49555 12.5228Z"
          fill="#FBBC02"
        />
        <path
          d="M5.49571 9.3377C6.455 6.32646 10.5575 4.58102 13.3062 7.1552L15.7065 4.79955C12.3029 1.52651 5.67025 1.65776 2.74629 7.19849L5.49571 9.337V9.3377Z"
          fill="#EA4335"
        />
      </svg>
    ),
    apple: (
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.2653 3.53125C11.6019 3.08787 12.0371 2.72074 12.5398 2.45605C13.0425 2.19136 13.6003 2.03564 14.1735 2C14.2234 2.49694 14.1679 2.99837 14.0101 3.47442C13.8523 3.95046 13.5955 4.39136 13.2551 4.77083C12.9442 5.18342 12.5281 5.51374 12.0461 5.73062C11.564 5.94751 11.0319 6.0438 10.5 6.01042C10.4448 5.56934 10.4842 5.12218 10.6157 4.69603C10.7473 4.26988 10.9683 3.87361 11.2653 3.53125ZM7.43878 6.22917C5.29592 6.22917 3 8.05208 3 11.5521C3 15.125 5.67857 19.5 7.82143 19.5C8.58673 19.5 9.73469 18.7708 10.8827 18.7708C12.0306 18.7708 12.8724 19.4271 13.9439 19.4271C16.3163 19.4271 18 14.7604 18 14.7604C17.2687 14.4597 16.6465 13.9606 16.211 13.3252C15.7755 12.6898 15.5459 11.9464 15.551 11.1875C15.5515 10.5223 15.7356 9.86899 16.0848 9.29304C16.4341 8.7171 16.9362 8.23883 17.5408 7.90625C17.1485 7.34572 16.6118 6.89049 15.982 6.58409C15.3522 6.27769 14.6505 6.13038 13.9439 6.15625C12.4133 6.15625 11.2653 6.95833 10.6531 6.95833C9.96429 6.95833 8.81633 6.22917 7.43878 6.22917Z"
          fill="black"
        />
      </svg>
    ),
    linkedin: (
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.7917 2.625H3.625C3.29348 2.625 2.97554 2.7567 2.74112 2.99112C2.5067 3.22554 2.375 3.54348 2.375 3.875V18.0417C2.375 18.3732 2.5067 18.6911 2.74112 18.9256C2.97554 19.16 3.29348 19.2917 3.625 19.2917H17.7917C18.1232 19.2917 18.4411 19.16 18.6756 18.9256C18.91 18.6911 19.0417 18.3732 19.0417 18.0417V3.875C19.0417 3.54348 18.91 3.22554 18.6756 2.99112C18.4411 2.7567 18.1232 2.625 17.7917 2.625ZM7.375 16.7917H4.875V9.29167H7.375V16.7917ZM6.125 7.83333C5.83849 7.82514 5.56074 7.7327 5.32646 7.56756C5.09218 7.40242 4.91176 7.17191 4.80775 6.90481C4.70373 6.63772 4.68073 6.3459 4.74162 6.06581C4.8025 5.78572 4.94458 5.52978 5.15009 5.32998C5.35561 5.13017 5.61544 4.99536 5.89714 4.94239C6.17883 4.88941 6.46989 4.92062 6.73395 5.03212C6.998 5.14362 7.22335 5.33046 7.38183 5.56929C7.5403 5.80813 7.62488 6.08837 7.625 6.375C7.61842 6.76696 7.45695 7.14038 7.17588 7.41364C6.8948 7.6869 6.51699 7.83779 6.125 7.83333ZM16.5417 16.7917H14.0417V12.8417C14.0417 11.6583 13.5417 11.2333 12.8917 11.2333C12.7011 11.246 12.5149 11.2962 12.3438 11.3811C12.1727 11.4659 12.02 11.5838 11.8946 11.7278C11.7691 11.8718 11.6734 12.0392 11.6128 12.2204C11.5523 12.4015 11.5281 12.5928 11.5417 12.7833C11.5375 12.8221 11.5375 12.8612 11.5417 12.9V16.7917H9.04167V9.29167H11.4583V10.375C11.7021 10.0042 12.037 9.70214 12.431 9.49786C12.825 9.29358 13.2648 9.19389 13.7083 9.20833C15 9.20833 16.5083 9.925 16.5083 12.2583L16.5417 16.7917Z"
          fill="#0A66C2"
        />
        <path d="M4.875 16.7917H7.375V9.29167H4.875V16.7917Z" fill="white" />
        <path
          d="M5.32646 7.56756C5.56074 7.7327 5.83849 7.82514 6.125 7.83333C6.51699 7.83779 6.8948 7.6869 7.17588 7.41364C7.45695 7.14038 7.61842 6.76696 7.625 6.375C7.62488 6.08837 7.5403 5.80813 7.38183 5.56929C7.22335 5.33046 6.998 5.14362 6.73395 5.03212C6.46989 4.92062 6.17883 4.88941 5.89714 4.94239C5.61544 4.99536 5.35561 5.13017 5.15009 5.32998C4.94458 5.52978 4.8025 5.78572 4.74162 6.06581C4.68073 6.3459 4.70373 6.63772 4.80775 6.90481C4.91176 7.17191 5.09218 7.40242 5.32646 7.56756Z"
          fill="white"
        />
        <path
          d="M14.0417 16.7917H16.5417L16.5083 12.2583C16.5083 9.925 15 9.20833 13.7083 9.20833C13.2648 9.19389 12.825 9.29358 12.431 9.49786C12.037 9.70214 11.7021 10.0042 11.4583 10.375V9.29167H9.04167V16.7917H11.5417V12.9C11.5375 12.8612 11.5375 12.8221 11.5417 12.7833C11.5281 12.5928 11.5523 12.4015 11.6128 12.2204C11.6734 12.0392 11.7691 11.8718 11.8946 11.7278C12.02 11.5838 12.1727 11.4659 12.3438 11.3811C12.5149 11.2962 12.7011 11.246 12.8917 11.2333C13.5417 11.2333 14.0417 11.6583 14.0417 12.8417V16.7917Z"
          fill="white"
        />
      </svg>
    ),
  };
